import { render, staticRenderFns } from "./AboutSiteDialog.vue?vue&type=template&id=53b21e80&scoped=true&"
import script from "./AboutSiteDialog.vue?vue&type=script&lang=js&"
export * from "./AboutSiteDialog.vue?vue&type=script&lang=js&"
import style0 from "./AboutSiteDialog.vue?vue&type=style&index=0&id=53b21e80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b21e80",
  null
  
)

export default component.exports